import { lazy, Suspense } from 'react'

import { useBreakpoints } from '@/hooks/useBreakpoints'

type RouterDevtoolsPanelProps = {
  initialIsOpen?: boolean
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
}

const EmptyRouterDevtools = (_props: RouterDevtoolsPanelProps) => null

const TanStackRouterDevtools = import.meta.env.DEV
  ? lazy(async () => {
      try {
        const module = await import('@tanstack/react-router-devtools')
        return { default: module.TanStackRouterDevtools }
      } catch (error) {
        console.warn('Unable to load TanStack Router Devtools.', error)
        return { default: EmptyRouterDevtools }
      }
    })
  : null

export const RouterDevtoolsPanel = ({
  initialIsOpen = false,
  position,
}: RouterDevtoolsPanelProps) => {
  const { isMobile } = useBreakpoints()
  if (isMobile || !import.meta.env.DEV || !TanStackRouterDevtools) {
    return null
  }

  return (
    <Suspense fallback={null}>
      <TanStackRouterDevtools initialIsOpen={initialIsOpen} position={position} />
    </Suspense>
  )
}
